import { SelectBaseProps } from 'govwell-ui/components/Select/types'

import { FormulaOutputUserType, UserDataFragment } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import StaffUserSelect from '../../Selects/StaffUserSelect'

type Props<TKey extends string> = Omit<
  SelectBaseProps<UserDataFragment>,
  'getOptionKey' | 'options'
> & {
  type: FormulaOutputUserType
} & SelectFieldProps<UserDataFragment, TKey>
const StaffUserSelectField = <TKey extends string>({
  field,
  filterOption,
  isDisabled,
  isMultiSelect,
  isRequired,
  label,
  type,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  const commonProps = {
    errorMessage,
    filterOption,
    isDisabled,
    isInvalid: !!errorMessage,
    isRequired: isRequired,
    onBlur: field.handleBlur,
    label: label,
    type: type,
  }

  if (isMultiSelect) {
    return (
      <StaffUserSelect
        isMultiSelect
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <StaffUserSelect
      isMultiSelect={false}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default StaffUserSelectField
